import { 
  AppBar, 
  Toolbar, 
  Container, 
  Box 
} from '@mui/material';

const Header = () => {
  return (
    <AppBar 
      position="static" 
      elevation={0}
      sx={{ bgcolor: '#012972' }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img 
              src="/logo.svg" 
              alt="SINQ Leads Logo" 
              style={{ 
                height: '40px',
                marginRight: '8px'
              }} 
            />
          </Box>
          
          <Box sx={{ flexGrow: 1 }} />
          
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header; 